var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trend__Category=Trend, Type=down, State=Default, Size=24, Style=Error",
    className: "trend__Category=Trend, trend__Type=down, trend__State=Default, trend__Size=24, trend__Style=Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trend__primary-shape",
    fill: "#FF7676",
    d: "M21 12.292a1 1 0 1 0-2 0v2.3l-4.24-5a1 1 0 0 0-1.27-.21l-4.27 2.61-4.45-5.34a1.001 1.001 0 1 0-1.54 1.28l5 6a1 1 0 0 0 1.28.22l4.28-2.57 4 4.71H15a1 1 0 1 0 0 2h5a1.1 1.1 0 0 0 .36-.07l.14-.08c.052-.026.103-.056.15-.09a.752.752 0 0 0 .14-.17.928.928 0 0 0 .09-.14.64.64 0 0 0 .05-.17.78.78 0 0 0 .07-.28v-5Z",
    className: "trend__primary-shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend_down.65e36a87390e2f90802c416e56415ed0.svg";
export { ForwardRef as ReactComponent };